import { useEffect, useState } from "react";
import { VStack } from "native-base";
import FileUploader from "../../../../containers/fileUpload";
import { hasPermission } from "../../../../utils/permission";
import Dropdown from "../../../../components/dropdown";

export const AddNewPeople = ({ file, setFile, forceRemount = false }) => {
  const [selectedValue, setSelectedValue] = useState("");

  useEffect(() => {
    setSelectedValue("");
  }, [forceRemount]);

  const options = [
    { id: "1", value: "internal", label: "Internal" },
    { id: "2", value: "external", label: "External" },
  ];

  const onInputChange = (e, eName) => {
    setSelectedValue(e);
  };
  return (
    <VStack>
      {/* {hasPermission("UPLOAD_INDIVIDUAL_DOCS") && (
        <Dropdown
          name="attendee_type"
          dropItems={options}
          defaultValue={""}
          selectedValues={selectedValue}
          setSelectedValues={onInputChange}
          placeholder="Internal/ External"
          width="50%"
          forceRemount={forceRemount}
        />
      )} */}
      <FileUploader
        files={file}
        setFiles={setFile}
        templates={true}
        forceRemount={forceRemount}
      />
    </VStack>
  );
};
